import {Circle as CircleStyle, Fill, Stroke, Style, Text} from "ol/style";

/**
 * Draw styles for the map of the photovoltaikcheck
 */
export class DrawStyle extends Style {
  constructor() {
    super({
      fill: new Fill({
        color: 'rgba(255, 105, 180, 0.5)',
      }),
      stroke: new Stroke({
        color: '#FF41FF',
        width: 2
      }),
      image: new CircleStyle({
        radius: 6,
        fill: new Fill({
          color: '#FF41FF'
        }),
        stroke: new Stroke({
          color: '#ffffff',
          width: 2
        })
      }),

      // styles for the labeltext
      text: new Text({
        text: '',
        font: '14px Roboto,sans-serif',
        // text color
        fill: new Fill({
          color: '#222'
        }),
        // text shadow
        stroke: new Stroke({
          color: '#fff',
          width: 3
        }),
        overflow: true,
        // position of the next
        offsetY: -20
      })
    });
  }
}
